import { API_CONFIG } from '../lib/apiConfig';
import { createPngMetaOverlayHook } from '../lib/hookFactories';

/**
 * Finds the precomputed Stand Density PNG overlay + geographic bounds for
 * (mill, drive_time). The hook only fetches the small `.meta.json` sidecar;
 * Leaflet's ImageOverlay loads the PNG bytes itself when rendered.
 */
export const useSdOverlay = createPngMetaOverlayHook({
  metaPath: API_CONFIG.s3.paths.sdOverlayMeta,
  pngPath: API_CONFIG.s3.paths.sdOverlay,
});
